/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import FormikFormGroupDumb from './FormikFormGroupDumb';
import { isTouchDevice } from 'src/shared/app/base/selector/appDeviceSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

const mapStateToProps = (state: State, inputProps: Object): Object => ({
  inputProps,
  isTouchDevice: isTouchDevice(state),
});

export default compose(connect(mapStateToProps))(FormikFormGroupDumb);
